<app-performanceprofiles-table [performanceProfiles]="performanceProfiles$ | async"
    (editExpires)="editExpires($event)"></app-performanceprofiles-table>